import * as React from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';

import { Props } from '../BaggageBody';
import { useTheme } from '../../../../../theme';
import BaggagePassenger from '../../BaggagePassenger/BaggagePassenger';
import BaggageSegment from '../../BaggageSegment/BaggageSegment';
import { getAvailableSegmentIds } from '../../../store/selector';

const BySegment: React.FC<Props> = props => {
	const commonTheme = useTheme('UpgradeBaggageDialog').UpgradeBaggageDialog;

	const availableSegmentIds = useSelector(getAvailableSegmentIds);

	return (
		<div className={cn(commonTheme.body, { [commonTheme.withTabs]: !!props.baggageTab })}>
			{props.segments.map(segment => {
				const isAvailable = availableSegmentIds.includes(segment.id);

				return (
					<React.Fragment key={segment.id}>
						<BaggageSegment
							segment={segment}
							baggageByRfics={props.upgradeBaggages}
							baggageTab={props.baggageTab}
							mobileSelectedServiceId={props.mobileSelectedServiceId}
							isAvailable={isAvailable}
							valueAlign={props.valueAlign}
						/>

						{props.passengers.map((passenger, i: number) => {
							const key = `${segment.id}_${passenger.id}`;
							const label = props.passengerLabels[passenger.id];
							const number = i + 1;
							const includedSegment = props.upgradeBaggages[0][0].segmentIds?.some(segments =>
								segments.includes(segment.id)
							);

							return (
								<BaggagePassenger
									baggageByRfics={props.upgradeBaggages}
									name={label}
									number={number}
									key={key}
									includedSegment={includedSegment}
									segmentId={segment.id}
									mobileSelectedServiceId={props.mobileSelectedServiceId}
									isAvailable={isAvailable}
									passenger={passenger}
									align={props.valueAlign}
								/>
							);
						})}
					</React.Fragment>
				);
			})}
		</div>
	);
};

export default BySegment;
